import React from 'react';
import { motion } from 'framer-motion';
interface FingerprintProps {
  className?: string;
  animated?: boolean;
}
export function Fingerprint({
  className = '',
  animated = false
}: FingerprintProps) {
  return <svg viewBox="0 0 100 120" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-129">
      {/* Abstract circuit-board fingerprint paths */}
      <path d="M50 10 C 25 10, 10 30, 10 60 C 10 90, 25 110, 50 110" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="opacity-80" data-id="element-130" />
      <path d="M50 25 C 35 25, 25 40, 25 60 C 25 80, 35 95, 50 95" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="opacity-90" data-id="element-131" />
      <path d="M50 40 C 42 40, 38 48, 38 60 C 38 72, 42 80, 50 80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-132" />

      <path d="M50 10 C 75 10, 90 30, 90 60 C 90 90, 75 110, 50 110" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="10 6" className="opacity-80" data-id="element-133" />
      <path d="M50 25 C 65 25, 75 40, 75 60 C 75 80, 65 95, 50 95" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="15 8" className="opacity-90" data-id="element-134" />
      <path d="M50 40 C 58 40, 62 48, 62 60 C 62 72, 58 80, 50 80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="8 4" data-id="element-135" />

      {/* Circuit dots */}
      <circle cx="50" cy="10" r="3" fill="currentColor" data-id="element-136" />
      <circle cx="50" cy="110" r="3" fill="currentColor" data-id="element-137" />
      <circle cx="25" cy="60" r="3" fill="currentColor" data-id="element-138" />
      <circle cx="75" cy="60" r="3" fill="currentColor" data-id="element-139" />
      <circle cx="90" cy="60" r="3" fill="currentColor" data-id="element-140" />

      {/* Animated data flow dots */}
      {animated && <>
          <motion.circle cx="10" cy="60" r="2.5" fill="#004AC7" animate={{
        cx: [10, 25, 50],
        cy: [60, 25, 10],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-141" />
          <motion.circle cx="90" cy="60" r="2.5" fill="#004AC7" animate={{
        cx: [90, 75, 50],
        cy: [60, 95, 110],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} data-id="element-142" />
          <motion.circle cx="50" cy="110" r="2.5" fill="#004AC7" animate={{
        cx: [50, 25, 10],
        cy: [110, 95, 60],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 3.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} data-id="element-143" />
        </>}
    </svg>;
}